export default {
  header: 'Menü Wählen',
  open_now: 'Jetzt Offen',
};
